(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-custom"] && !Shopify.designMode) return;
  try {
    /* ────────────────────────────────────────────────────────────────────
   Rating widget relocator
   ────────────────────────────────────────────────────────────────────
   Some review apps (BK Reviews, etc.) auto-inject their widgets as
   direct children of the product card root — meaning the widget lands
   as a sibling of .mfpc__link instead of next to the title.

   The snippet now ships an empty .mfpc__rating slot between the title
   and the price. This script:
     1. On initial load, moves any non-structural direct child of .mfpc
        (= an auto-injected widget) into the slot.
     2. Uses MutationObserver to catch widgets that inject after page
        load AND newly-rendered cards from AJAX (quick-add, related
        products, infinite scroll).

   If the review app honors the data-product-id attributes on the slot
   and injects directly into it, this script does nothing (widget is
   already in the right place, not a direct child to relocate).
   ──────────────────────────────────────────────────────────────────── */
(function () {
  if (window.__mfpcRatingRelocatorBound) return;
  window.__mfpcRatingRelocatorBound = true;

  var STRUCTURAL = ['mfpc__link', 'mfpc__btn', 'mfpc__btn--disabled', 'mfpc__form'];

  function isStructural(el) {
    if (!el.classList) return false;
    for (var i = 0; i < STRUCTURAL.length; i++) {
      if (el.classList.contains(STRUCTURAL[i])) return true;
    }
    return false;
  }

  function relocate(card) {
    var slot = card.querySelector('.mfpc__rating');
    if (!slot) return;
    Array.prototype.slice.call(card.children).forEach(function (child) {
      if (!isStructural(child)) slot.appendChild(child);
    });
  }

  function relocateAll(root) {
    (root || document).querySelectorAll('.mfpc').forEach(relocate);
  }

  function init() {
    relocateAll();

    // Catches async-loaded widgets AND AJAX-loaded cards
    var obs = new MutationObserver(function (muts) {
      var cards = new Set();
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // text nodes etc.
          if (node.classList && node.classList.contains('mfpc')) {
            cards.add(node);
          } else if (node.closest) {
            var card = node.closest('.mfpc');
            if (card) cards.add(card);
          }
        });
      });
      cards.forEach(relocate);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
